<template>
  <div>
    <b-button
      v-if="!noBtn"
      variant="success"
      @click="toggleModal()"
    >
      <i class="uil uil-plus-circle mr-1"></i>
      {{ $t('credits.direct_deposit')}}
    </b-button>
    <b-modal
      v-model="isDirectDepositModalActive"
      :title="`${$t('credits.direct_deposit')}`"
      hide-footer
    >
      <ValidationObserver
        ref="depositForm"
        v-slot="{ handleSubmit }"
      >
        <form @submit.prevent="handleSubmit(onSubmit)">
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('credits.credit_amount')"
            rules="required|min_value:1"
          >
            <b-form-group
              label-cols-sm="12"
              label-cols-lg="3"
              :label="`${$t('credits.credit_amount')} *`"
              label-for="amount"
            >
              <b-form-input
                id="amount"
                v-model="transferForm.amount"
                type="number"
                :state="errors[0] ? false : null"
              ></b-form-input>
            </b-form-group>
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            :name="$t('fields.remark')"
            rules="required"
          >
            <b-form-group
              label-cols-sm="12"
              label-cols-lg="3"
              :label="`${$t('fields.remark')} *`"
              label-for="detail"
            >
              <b-form-textarea
                id="detail"
                v-model="transferForm.detail"
                :state="errors[0] ? false : null"
              ></b-form-textarea>
            </b-form-group>

          </ValidationProvider>
          <div class="text-right">
            <b-button
              variant="light"
              class="mr-2"
              @click="onCloseModal"
            >
              {{ $t('buttons.cancel')}}
            </b-button>
            <b-overlay
              :show="isDepositting"
              rounded
              spinner-small
              class="d-inline-block"
            >
              <b-button
                type="submit"
                variant="primary"
                block
              >
                {{ $t('buttons.confirm')}}
              </b-button>
            </b-overlay>
          </div>
        </form>
      </ValidationObserver>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    noBtn: {
      type: Boolean,
      default: false,
    },
    agentId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isDirectDepositModalActive: false,
      transferForm: {
        amount: 0,
        detail: '',
      },
    }
  },
  computed: {
    ...mapState({
      isDepositting: (state) => state.agent.isDepositingAgentCredit,
    }),
  },
  created() {
    this.setData()
  },
  methods: {
    ...mapActions(['depositAgentCredit']),
    setData() {
      this.transferForm = {
        amount: 0,
        detail: '',
      }
    },
    toggleModal() {
      this.isDirectDepositModalActive = !this.isDirectDepositModalActive
    },
    onCloseModal() {
      this.isDirectDepositModalActive = false
      this.setData()
    },
   async onSubmit() {
      this.transferForm.amount = +this.transferForm.amount
      await this.depositAgentCredit({
        agentId: this.agentId,
        data: this.transferForm,
      })
      this.onCloseModal()
    },
  },
}
</script>